import React, {useState} from 'react';
import {useSnackbar} from 'notistack';
import {useQueryClient} from '@tanstack/react-query';
import {Link, Stack, Typography} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {useBusyCallback, useHotkey} from '../util/react_hooks.js';
import api from '../util/api.js';
import {openModal} from './Modals.js';
import {openLoginModal} from './Login.js';
import SCButton from './SCButton.js';
import SCTextField from './SCTextField.js';
import ConsentCheckbox from './ConsentCheckbox.js';

const SignupConfirm = props=>{
    let {email} = props;
    return <Stack gap={2} direction="column">
      <Stack gap={2} direction="row" alignItems="center">
        <CheckCircleIcon sx={{color: 'status.success'}}/>
        <Typography>נשלח מייל אימות לכתובת <strong>{email}</strong></Typography>
      </Stack>
      <Typography>להשלמת ההרשמה וכניסה למערכת, לחצו על הלינק שקיבלתם במייל</Typography>
    </Stack>;
};

export const SignupForm = ()=>{
    let [email, setEmail] = useState('');
    let [password, setPassword] = useState('');
    let [repeatPassword, setRepeatPassword] = useState('');
    let [username, setUsername] = useState('');
    let [consent, setConsent] = useState(false);
    let queryClient = useQueryClient();
    let {enqueueSnackbar} = useSnackbar();
    let [onConfirm, confirming] = useBusyCallback(async ()=>{
        try {
            await api.signup({email, password, repeatPassword, username});
            openModal({
                header: 'הרשמה',
                content: <SignupConfirm email={email}/>,
            });
        } catch (e) {            
            // TODO: modularize (like alert_err)
            let msg = 'אירעה שגיאה, נסו שוב מאוחר יותר';
            if (e.code=='user_exists')
                msg = 'המייל הזה כבר בשימוש';
            if (e.code=='validation_error')
                msg = e.extra.map(c=>c.message).filter(Boolean).join(', ');
            enqueueSnackbar(msg, {variant: 'error'});
        }
    }, [email, password, repeatPassword, username, queryClient, enqueueSnackbar]);
    useHotkey('Enter', onConfirm);
    return <Stack direction="column" gap={2} justifyContent="center" alignItems="center">
      <SCTextField required label="שם משתמש" variant="outlined" value={username} onChange={setUsername}/>
      <SCTextField required label={`דוא"ל`} variant="outlined" value={email} onChange={setEmail}/>
      <SCTextField required label="סיסמה" type="password" variant="outlined" value={password} onChange={setPassword}/>
      <SCTextField required label="אימות סיסמה" type="password" variant="outlined" value={repeatPassword} onChange={setRepeatPassword}/>
      <ConsentCheckbox value={consent} onChange={setConsent}/>
      <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
        <SCButton text="הרשמה" variant="contained" onClick={onConfirm} loading={confirming} disabled={!consent} size="large"/>
        <Link onClick={openLoginModal}>התחברות עם משתמש קיים</Link>
      </Stack>
    </Stack>;
};

export const openSignupModal = ()=>openModal({
    header: 'הרשמה',
    content: <SignupForm/>,
});
